import React from 'react';

const PreferencesMenu = ({
    showPreferencesMenu,
    messageViewMode,
    setMessageViewMode,
    sortOrder,
    setSortOrder,
    preferenceFilters,
    setPreferenceFilters,
    showMoreFilters,
    setShowMoreFilters,
}) => {
    if (!showPreferencesMenu) return null;

    return (
        <div className="preferences-menu">
            <div className="view-toggle-row">
                <button
                    type="button"
                    className={
                        messageViewMode === 'expanded'
                            ? 'view-toggle active'
                            : 'view-toggle'
                    }
                    onClick={() => setMessageViewMode('expanded')}
                >
                    Expanded
                </button>

                <button
                    type="button"
                    className={
                        messageViewMode === 'compact'
                            ? 'view-toggle active'
                            : 'view-toggle'
                    }
                    onClick={() => setMessageViewMode('compact')}
                >
                    Compact
                </button>
            </div>

            <select
                className="sort-select"
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
            >
                <option value="newest">Sort by: Newest first</option>
                <option value="oldest">Sort by: Oldest first</option>
            </select>

            <label className="preference-toggle">
                Unread
                <input
                    type="checkbox"
                    checked={preferenceFilters.unread}
                    onChange={() =>
                        setPreferenceFilters((prev) => ({
                            ...prev,
                            unread: !prev.unread,
                        }))
                    }
                />
            </label>

            {showMoreFilters && (
                <>
                    <label className="preference-toggle">
                        Read
                        <input
                            type="checkbox"
                            checked={preferenceFilters.read}
                            onChange={() =>
                                setPreferenceFilters((prev) => ({
                                    ...prev,
                                    read: !prev.read,
                                }))
                            }
                        />
                    </label>

                    <label className="preference-toggle">
                        Starred
                        <input
                            type="checkbox"
                            checked={preferenceFilters.starred}
                            onChange={() =>
                                setPreferenceFilters((prev) => ({
                                    ...prev,
                                    starred: !prev.starred,
                                }))
                            }
                        />
                    </label>

                    <label className="preference-toggle">
                        Has attachment
                        <input
                            type="checkbox"
                            checked={preferenceFilters.attachment}
                            onChange={() =>
                                setPreferenceFilters((prev) => ({
                                    ...prev,
                                    attachment: !prev.attachment,
                                }))
                            }
                        />
                    </label>
                </>
            )}

            <button
                type="button"
                className="more-filters-btn"
                onClick={() => setShowMoreFilters((prev) => !prev)}
            >
                {showMoreFilters ? 'Less filters' : 'More filters'}
            </button>
        </div>
    );
};

export default PreferencesMenu;